// =============================================================================
// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// =============================================================================
// Generated by: npx tsx scripts/generate-icon-registry.ts
// Generated at: 2026-04-01T18:30:50.368Z
// Total icons: 104
// =============================================================================

import type { Icon } from "@tabler/icons-react";
import {
  IconAlertCircle,
  IconAlertTriangle,
  IconAlignLeft,
  IconApi,
  IconArrowLeft,
  IconArrowsSplit,
  IconBraces,
  IconBrandAws,
  IconBrandAzure,
  IconBrandBootstrap,
  IconBrandGoogleDrive,
  IconBrandSlack,
  IconBrandTailwind,
  IconBug,
  IconCake,
  IconCalendar,
  IconCalendarTime,
  IconChartBar,
  IconCheck,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconChevronsLeft,
  IconCircle,
  IconCircleCheck,
  IconCirclePlus,
  IconCircleX,
  IconClock,
  IconCode,
  IconCopy,
  IconCreditCard,
  IconDashboard,
  IconDatabase,
  IconDatabaseSearch,
  IconDeviceDesktop,
  IconDeviceMobile,
  IconDeviceTablet,
  IconDownload,
  IconEdit,
  IconExternalLink,
  IconEye,
  IconFile,
  IconFileOff,
  IconFileText,
  IconFileUpload,
  IconFiles,
  IconFilter,
  IconFingerprint,
  IconForms,
  IconGift,
  IconGridPattern,
  IconGripVertical,
  IconHash,
  IconHelpCircle,
  IconHome,
  IconInbox,
  IconInfoCircle,
  IconLayout,
  IconLink,
  IconList,
  IconListCheck,
  IconLock,
  IconLogout,
  IconMail,
  IconMailSpark,
  IconMapOff,
  IconMapPin,
  IconMaximize,
  IconMenu,
  IconMinimize,
  IconNumbers,
  IconPalette,
  IconPaperclip,
  IconPentagon,
  IconPhone,
  IconPlugConnected,
  IconPlus,
  IconPrinter,
  IconRefresh,
  IconRegex,
  IconRoute,
  IconSandbox,
  IconSearch,
  IconSelector,
  IconSettings,
  IconShield,
  IconShieldCancel,
  IconShieldCheck,
  IconShieldExclamation,
  IconSquare,
  IconSquareCheck,
  IconTemplate,
  IconTextSize,
  IconToggleLeft,
  IconTrash,
  IconTrendingDown2,
  IconTrendingUp2,
  IconUser,
  IconUserCircle,
  IconUsers,
  IconVocabulary,
  IconWebhook,
  IconX,
  IconQuestionMark,
} from "@tabler/icons-react";

/**
 * Registry of icons used in the application.
 *
 * This includes:
 * - Icons detected by scanning <AppIcon iconName="..." /> in source code
 * - Icons manually specified in scripts/icons.config.ts
 *
 * To add new icons:
 * 1. Use them in code with <AppIcon iconName="CirclePlus" /> where "CirclePlus" is an example name of a new icon
 * 2. Or add to manualIcons in scripts/icons.config.ts
 * 3. Run: npm run icons
 */
export const IconRegistry: Record<string, Icon> = {
  "AlertCircle": IconAlertCircle,
  "AlertTriangle": IconAlertTriangle,
  "AlignLeft": IconAlignLeft,
  "Api": IconApi,
  "ArrowLeft": IconArrowLeft,
  "ArrowsSplit": IconArrowsSplit,
  "Braces": IconBraces,
  "BrandAws": IconBrandAws,
  "BrandAzure": IconBrandAzure,
  "BrandBootstrap": IconBrandBootstrap,
  "BrandGoogleDrive": IconBrandGoogleDrive,
  "BrandSlack": IconBrandSlack,
  "BrandTailwind": IconBrandTailwind,
  "Bug": IconBug,
  "Cake": IconCake,
  "Calendar": IconCalendar,
  "CalendarTime": IconCalendarTime,
  "ChartBar": IconChartBar,
  "Check": IconCheck,
  "ChevronDown": IconChevronDown,
  "ChevronLeft": IconChevronLeft,
  "ChevronRight": IconChevronRight,
  "ChevronUp": IconChevronUp,
  "ChevronsLeft": IconChevronsLeft,
  "Circle": IconCircle,
  "CircleCheck": IconCircleCheck,
  "CirclePlus": IconCirclePlus,
  "CircleX": IconCircleX,
  "Clock": IconClock,
  "Code": IconCode,
  "Copy": IconCopy,
  "CreditCard": IconCreditCard,
  "Dashboard": IconDashboard,
  "Database": IconDatabase,
  "DatabaseSearch": IconDatabaseSearch,
  "DeviceDesktop": IconDeviceDesktop,
  "DeviceMobile": IconDeviceMobile,
  "DeviceTablet": IconDeviceTablet,
  "Download": IconDownload,
  "Edit": IconEdit,
  "ExternalLink": IconExternalLink,
  "Eye": IconEye,
  "File": IconFile,
  "FileOff": IconFileOff,
  "FileText": IconFileText,
  "FileUpload": IconFileUpload,
  "Files": IconFiles,
  "Filter": IconFilter,
  "Fingerprint": IconFingerprint,
  "Forms": IconForms,
  "Gift": IconGift,
  "GridPattern": IconGridPattern,
  "GripVertical": IconGripVertical,
  "Hash": IconHash,
  "HelpCircle": IconHelpCircle,
  "Home": IconHome,
  "Inbox": IconInbox,
  "InfoCircle": IconInfoCircle,
  "Layout": IconLayout,
  "Link": IconLink,
  "List": IconList,
  "ListCheck": IconListCheck,
  "Lock": IconLock,
  "Logout": IconLogout,
  "Mail": IconMail,
  "MailSpark": IconMailSpark,
  "MapOff": IconMapOff,
  "MapPin": IconMapPin,
  "Maximize": IconMaximize,
  "Menu": IconMenu,
  "Minimize": IconMinimize,
  "Numbers": IconNumbers,
  "Palette": IconPalette,
  "Paperclip": IconPaperclip,
  "Pentagon": IconPentagon,
  "Phone": IconPhone,
  "PlugConnected": IconPlugConnected,
  "Plus": IconPlus,
  "Printer": IconPrinter,
  "Refresh": IconRefresh,
  "Regex": IconRegex,
  "Route": IconRoute,
  "Sandbox": IconSandbox,
  "Search": IconSearch,
  "Selector": IconSelector,
  "Settings": IconSettings,
  "Shield": IconShield,
  "ShieldCancel": IconShieldCancel,
  "ShieldCheck": IconShieldCheck,
  "ShieldExclamation": IconShieldExclamation,
  "Square": IconSquare,
  "SquareCheck": IconSquareCheck,
  "Template": IconTemplate,
  "TextSize": IconTextSize,
  "ToggleLeft": IconToggleLeft,
  "Trash": IconTrash,
  "TrendingDown2": IconTrendingDown2,
  "TrendingUp2": IconTrendingUp2,
  "User": IconUser,
  "UserCircle": IconUserCircle,
  "Users": IconUsers,
  "Vocabulary": IconVocabulary,
  "Webhook": IconWebhook,
  "X": IconX,
};

/**
 * Fallback icon shown when requested icon doesn't exist
 */
export const FallbackIcon = IconQuestionMark;

/**
 * Check if an icon exists in the registry
 */
export function hasIcon(name: string): boolean {
  return name in IconRegistry;
}

/**
 * Get an icon from the registry (with fallback)
 */
export function getIcon(name: string): Icon {
  return IconRegistry[name] || FallbackIcon;
}

/**
 * List of all available icon names
 */
export const availableIcons: string[] = [
  "AlertCircle",
  "AlertTriangle",
  "AlignLeft",
  "Api",
  "ArrowLeft",
  "ArrowsSplit",
  "Braces",
  "BrandAws",
  "BrandAzure",
  "BrandBootstrap",
  "BrandGoogleDrive",
  "BrandSlack",
  "BrandTailwind",
  "Bug",
  "Cake",
  "Calendar",
  "CalendarTime",
  "ChartBar",
  "Check",
  "ChevronDown",
  "ChevronLeft",
  "ChevronRight",
  "ChevronUp",
  "ChevronsLeft",
  "Circle",
  "CircleCheck",
  "CirclePlus",
  "CircleX",
  "Clock",
  "Code",
  "Copy",
  "CreditCard",
  "Dashboard",
  "Database",
  "DatabaseSearch",
  "DeviceDesktop",
  "DeviceMobile",
  "DeviceTablet",
  "Download",
  "Edit",
  "ExternalLink",
  "Eye",
  "File",
  "FileOff",
  "FileText",
  "FileUpload",
  "Files",
  "Filter",
  "Fingerprint",
  "Forms",
  "Gift",
  "GridPattern",
  "GripVertical",
  "Hash",
  "HelpCircle",
  "Home",
  "Inbox",
  "InfoCircle",
  "Layout",
  "Link",
  "List",
  "ListCheck",
  "Lock",
  "Logout",
  "Mail",
  "MailSpark",
  "MapOff",
  "MapPin",
  "Maximize",
  "Menu",
  "Minimize",
  "Numbers",
  "Palette",
  "Paperclip",
  "Pentagon",
  "Phone",
  "PlugConnected",
  "Plus",
  "Printer",
  "Refresh",
  "Regex",
  "Route",
  "Sandbox",
  "Search",
  "Selector",
  "Settings",
  "Shield",
  "ShieldCancel",
  "ShieldCheck",
  "ShieldExclamation",
  "Square",
  "SquareCheck",
  "Template",
  "TextSize",
  "ToggleLeft",
  "Trash",
  "TrendingDown2",
  "TrendingUp2",
  "User",
  "UserCircle",
  "Users",
  "Vocabulary",
  "Webhook",
  "X"
];
